import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getReportsReporting(companyId, query) {
  return dataTransferWrap(ModulesMap.REPORTS_REPORTING,dtConfig[ModulesMap.REPORTS_REPORTING].getReportsReporting,
    {
      urlParams: {
        companyId
      },
      params: query,
    })
}

function getReportReporting(companyId, reportingId) {
  return dataTransferWrap(ModulesMap.REPORTS_REPORTING,dtConfig[ModulesMap.REPORTS_REPORTING].getReportReporting,
    {
      urlParams:
        { companyId, reportingId },
    })
}

function getReportReportingPreview(companyId, reportingId) {
  return dataTransferWrap(ModulesMap.REPORTS_REPORTING,dtConfig[ModulesMap.REPORTS_REPORTING].getReportReportingPreview,
    {
      urlParams:
        { companyId, reportingId },
    })
}

export default {
  getReportsReporting,
  getReportReporting,
  getReportReportingPreview,
}